import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="red-bar" />
    <div className="footer__main py-5">
      <div className="container-xl">
        <div className="row g-4 g-lg-5">

          <div className="col-12 col-md-6 col-lg-4 footer__brand">
            <img src="/images/logo-white.png" alt="Pace Plan LLC" className="footer__logo" />
            <p className="footer__tagline">ADA Compliance · Parking Lot Striping<br />Pressure Washing · Commercial Services</p>
            <div className="footer__cert d-flex gap-2 mb-2">
              <span className="cert-badge">★ SDVOSB</span>
              <span className="cert-badge">★ VOSB</span>
            </div>
            <p className="footer__cert-label">SBA Certified — Service-Disabled & Veteran-Owned Small Business</p>
          </div>

          <div className="col-6 col-md-3 col-lg-2 footer__col">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services#striping">Parking Lot Striping</Link></li>
              <li><Link to="/services#ada">ADA Compliance</Link></li>
              <li><Link to="/services#pressure">Pressure Washing</Link></li>
              <li><Link to="/services#softwash">Soft Wash</Link></li>
              <li><Link to="/services#junk">Junk Removal</Link></li>
              <li><Link to="/services#dumpster">Dumpster Cleanup</Link></li>
            </ul>
          </div>

          <div className="col-6 col-md-3 col-lg-2 footer__col">
            <h4>Company</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="col-12 col-md-6 col-lg-4 footer__col">
            <h4>Contact</h4>
            <ul className="footer__contact">
              <li>
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.22 1.18 2 2 0 012.22 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                <a href="tel:3464194499">(346) 419-4499</a>
              </li>
              <li>
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                <a href="mailto:paceplanllcgroup@gmail.com">paceplanllcgroup@gmail.com</a>
              </li>
              <li>
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                <span>12335 Kingsride Ln #319<br />Houston, TX 77042</span>
              </li>
              <li>
                <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></svg>
                <span>Mon–Sat: 7am–7pm<br />Emergency available</span>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
    <div className="footer__bottom">
      <div className="container-xl d-flex flex-wrap justify-content-between align-items-center gap-2">
        <p>© {new Date().getFullYear()} Pace Plan LLC · Greater Houston, TX · paceplanhtx.com</p>
        <p>SBA Certified SDVOSB & VOSB · Licensed & Insured · State of Texas</p>
      </div>
    </div>
  </footer>
);

export default Footer;
